/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { createRecommendationsRequestSchema } from "./createRecommendationsRequestSchema.ts";
import { errorResponseSchema } from "./errorResponseSchema.ts";

export const recommendationsUpdateCreatePathOrgUnitIdSchema = z.uuid();

export const recommendationsUpdateCreateStatus200Schema = z.any();

export const recommendationsUpdateCreateStatus400Schema = errorResponseSchema;

export const recommendationsUpdateCreateResponseSchema = z.union([recommendationsUpdateCreateStatus200Schema, recommendationsUpdateCreateStatus400Schema]);

export const recommendationsUpdateCreateDataSchemaJson = createRecommendationsRequestSchema.optional().describe("Сериализатор создания рекомендаций.");

export const recommendationsUpdateCreateDataSchemaXml = createRecommendationsRequestSchema.optional().describe("Сериализатор создания рекомендаций.");

export const recommendationsUpdateCreateDataSchema = z.union([recommendationsUpdateCreateDataSchemaJson, recommendationsUpdateCreateDataSchemaXml]);
